import {default as Base} from '../services/services.Utils.js';

export default class Pmf extends Base {

  static get baseUrl() {
    // return "http://localhost:8000";
    return Utils.Configuration.pmfBaseUrl + Utils.Configuration.pmfService;
  }

  constructor() {
    super();
  }

  static getPmfQtList(jsonData) {
    const data = jsonData ? JSON.stringify(jsonData) : null;
    return super.doTheCall(data, {type: 'POST', url: Pmf.baseUrl + '/dashboardEmployee/summaryQt'});
  }

  static getPmfQlList(jsonData) {
    const data = jsonData ? JSON.stringify(jsonData) : null;
    return super.doTheCall(data, {type: 'POST', url: Pmf.baseUrl + '/dashboardEmployee/summaryQl'});
  }

  static getPmfQtDetail(pmfId) {
    return super.doTheCall(null, {type: 'GET', url: Pmf.baseUrl + '/analyticsEmployee/detailQt/' + pmfId});
  }

  static getPmfQlDetail(pmfId) {
    return super.doTheCall(null, {type: 'GET', url: Pmf.baseUrl + '/analyticsEmployee/detailQl/' + pmfId});
  }

  static getPmfQlResult(pmfId) {
    return super.doTheCall(null, {type: 'GET', url: Pmf.baseUrl + '/analyticsEmployee/resultQl/' + pmfId});
  }

  static getPmfQtHistory(pmfId) {
    const data = JSON.stringify({IdPmfQt: pmfId});
    return super.doTheCall(data, {type: 'POST', url: Pmf.baseUrl + '/analyticsEmployee/historyQt'})
  }

  static getPmfQlHistory(pmfId) {
    return super.doTheCall(null, {type: 'GET', url: Pmf.baseUrl + '/analyticsEmployee/historyQl/' + pmfId});
  }

  /*** INDEX ***/

  static getIndexList(jsonData) {
    const data = jsonData ? JSON.stringify(jsonData) : null;
    return super.doTheCall(data, {type: 'POST', url: Pmf.baseUrl + '/analyticsIdxEmployee/list'});
  }

  static getIndexDetailList(jsonData, id) {
    const data = jsonData ? JSON.stringify(jsonData) : null;
    return super.doTheCall(data, {type: 'POST', url: Pmf.baseUrl + '/analyticsIdxEmployee/results/'+id});
  }

  static getIndexDataById(jsonData, id) {
    const data = jsonData ? JSON.stringify(jsonData) : null;
    return super.doTheCall(data, {type: 'POST', url: Pmf.baseUrl + '/analyticsIdxEmployee/history/'+id});
  }

  static getIndexDetailInfo(id) {
    return super.doTheCall(null, {type: 'GET', url: Pmf.baseUrl + '/analyticsIdxEmployee/details/'+id});
  }
}
